//------------------------------------------------- PLUGINS
var app;

(function ($) {
  app = {
    //------------------------------------------------- ON READY
    init: function () {
      // Alerts
      $(".js--dismiss-alert").on("click", function (e) {
        e.preventDefault();

        var id = $(this).data("id"),
          cookie = "dismiss-alert-" + id,
          alert = ".js--site-alert-" + id;

        $(alert).slideUp(250, function () {
          Cookies.set(cookie, true, { expires: 60 });
        });
      });

      // Subscribe Popup
      $(".js--dismiss-popup").on("click", function (e) {
        e.preventDefault();

        var $el = $(".js--popup"),
          cookie = "subscribe_popup";

        $el.removeClass("is--visible");
        $el.delay(250).fadeOut(0, function () {
          Cookies.set(cookie, true, { expires: 60 });
          $el.removeClass("is--active");
        });
      });

      // Cookie Notice
      $(".js--dismiss-cookie").on("click", function (e) {
        e.preventDefault();

        var $el = $(".js--cookies"),
          allow = $(this).data("cookies"),
          cookie = "allow_cookies";

        if (allow == 0) {
          Cookies.set(cookie, false, { expires: 60 });
          Cookies.set("__kla_off", true, { expires: 60 });
        } else {
          Cookies.set(cookie, true, { expires: 60 });
        }

        $el.removeClass("is--active");
      });
    },
    //------------------------------------------------- USER INTERACTIONS
    interactive: function () {
      // Menu toggle
      $(".js--toggle-menu")
        .off()
        .on("click", function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();

          if ($(this).hasClass("is--open")) {
            $(this).removeClass("is--open");
            $(".js--nav-shop").removeClass("is--open");
            $(".js--nav-shop").fadeToggle(250);
          } else {
            $(".js--nav-shop").fadeIn(250);
            $(this).addClass("is--open");
            $(".js--nav-shop").addClass("is--open");
          }

          if (
            !$(this).hasClass("is--open") &&
            !$(".js--toggle-cart").hasClass("is--open")
          ) {
            $("body").removeClass("is--modal");
          } else {
            $("body").addClass("is--modal");
          }
        });

      // Account toggle
      $(".js--toggle-account")
        .off()
        .on("click", function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();

          if ($(this).hasClass("is--open")) {
            $(this).removeClass("is--open");
            $(".js--nav-account").slideUp(250);
          } else {
            $(this).addClass("is--open");
            $(".js--nav-account").slideDown(250);
          }
        });

      // Cart toggle
      $(".js--toggle-cart")
        .off()
        .on("click", function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();

          if ($(this).hasClass("is--open")) {
            $(this).removeClass("is--open");
            $(".js--cart-modal").removeClass("is--open");
            $(".js--cart-modal").fadeOut(250);
          } else {
            $(".js--cart-modal").fadeIn(250);
            $(this).addClass("is--open");
            $(".js--cart-modal").addClass("is--open");
          }

          if (
            !$(this).hasClass("is--open") &&
            !$(".js--toggle-menu").hasClass("is--open")
          ) {
            $("body").removeClass("is--modal");
          } else {
            $("body").addClass("is--modal");
          }
        });

      // Close cart on click
      $(".js--cart-modal").on("click", function (e) {
        if ($(e.target).is(this)) {
          $(this).removeClass("is--open");
          $(".js--toggle-cart").removeClass("is--open");
          $(this).fadeOut(250);
        }

        if (
          !$(".js--toggle-cart").hasClass("is--open") &&
          !$(".js--toggle-menu").hasClass("is--open")
        ) {
          $("body").removeClass("is--modal");
        }
      });

      // Edit profile
      $(".js--profile-edit").on("click", function (e) {
        e.preventDefault();

        $(".js--account-profile").addClass("is--editing");
      });
      $(".js--profile-edit-cancel").on("click", function (e) {
        e.preventDefault();

        $(".js--account-profile").removeClass("is--editing");
      });

      // Form Conditionals
      $(".js--conditional-check").on("change", function (e) {
        var cond = $(this).data("condition");

        if ($(this).prop("checked")) {
          $(".cond--" + cond).slideDown(250);
        } else {
          $(".cond--" + cond).slideUp(250);
        }
      });

      // Registration Form Catch
      $(".js--register").on("submit", function (e) {
        var $nmfr = $(this).find(".js--nmfr");

        if ($nmfr.val()) {
          e.preventDefault();
        }
      });

      // Contest Rules
      $(".js--contest-rules-toggle").on("click", function (e) {
        e.preventDefault();

        $(".js--contest-rules").slideToggle(250);
      });

      // Category Filters
      $(".js--toggle-filters").on("click", function (e) {
        e.preventDefault();

        $(".js--filter-wrapper").slideToggle(250);
      });

      // Smooth Scroll
      $(".js--scrollto").on("click", function (e) {
        e.preventDefault();

        var id = $(this).attr("href"),
          distance = $(id).offset().top,
          distance_nav = distance - $(".nav-main").outerHeight();

        if ($(id).hasClass("js--link-anchor")) {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: distance,
            },
            500,
          );
        } else {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: distance_nav,
            },
            500,
          );
        }
      });

      // S3 Artist File Uploads
      $(".js--s3-artist-upload").on("change", function (e) {
        var file = $(this).prop("files")[0],
          updated = $(this).data("updated"),
          preview = $(this).data("preview"),
          handle = $(this).data("handle"),
          now = new Date(),
          year = now.getFullYear(),
          month = now.getMonth() + 1,
          day = now.getDate(),
          hour = now.getHours(),
          minute = now.getMinutes(),
          second = now.getSeconds(),
          timestamp = day + month + year + "-" + hour + minute + second,
          filename = "artists/" + timestamp + "-" + handle + "-" + updated;

        if (file == null) {
          console.log("No file selected.");
        } else {
          if (file.type == "image/jpeg") {
            filename = filename + ".jpg";
            app.getSignedRequest(file, filename, updated, preview, "artists");
          } else if (file.type == "image/png") {
            filename = filename + ".png";
            app.getSignedRequest(file, filename, updated, preview, "artists");
          } else if (file.type == "image/gif") {
            filename = filename + ".gif";
            app.getSignedRequest(file, filename, updated, preview, "artists");
          } else {
            alert("Incorrect filetype. Please upload only jpg, png, or gif.");
          }
        }
      });

      $(".js--terms").modaal({
        background: "#3b48ed",
        overlay_opacity: 0.9,
      });

      // S3 Submission File Uploads
      $(".js--s3-sub-upload").on("change", function (e) {
        var file = $(this).prop("files")[0],
          updated = $(this).data("updated"),
          preview = $(this).data("preview"),
          name = $(this).data("custid"),
          now = new Date(),
          year = now.getFullYear(),
          month = now.getMonth() + 1,
          day = now.getDate(),
          hour = now.getHours(),
          minute = now.getMinutes(),
          second = now.getSeconds(),
          timestamp = day + month + year + "-" + hour + minute + second,
          filename = "submissions/" + timestamp + "-" + name;

        if (file == null) {
          console.log("No file selected.");
        } else {
          if (file.type == "image/jpeg") {
            app.getSignedRequest(
              file,
              filename,
              updated,
              preview,
              "submissions",
            );
          } else if (file.type == "image/png") {
            app.getSignedRequest(
              file,
              filename,
              updated,
              preview,
              "submissions",
            );
          } else {
            alert("Incorrect filetype. Please upload only jpg or png.");
          }
        }
      });
    },
    //------------------------------------------------- PLUGINS
    plugins: function () {},
    //------------------------------------------------- GET SIGNED REQUEST FROM S3
    getSignedRequest: function (file, filename, updated, preview, dest) {
      var xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
        "/apps/" +
          dest +
          "/sign-s3?file-name=" +
          filename +
          "&file-type=" +
          file.type,
      );
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            var response = JSON.parse(xhr.responseText);
            $("div." + preview).addClass("is--loading");
            app.uploadFile(
              file,
              response.signedRequest,
              response.url,
              updated,
              preview,
            );
          } else {
            alert("Could not get signed URL.");
          }
        }
      };
      xhr.send();
    },
    //------------------------------------------------- UPLOAD FILE TO S3
    uploadFile: function (file, signedRequest, url, updated, preview) {
      var xhr = new XMLHttpRequest();
      xhr.open("PUT", signedRequest);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            $("img." + preview).attr("src", url);
            $("div." + preview).removeClass("is--loading");
            $("div." + preview).addClass("is--loaded");
            $("input#" + updated).val(url);
          } else {
            alert("Could not upload file.");
          }
        }
      };
      xhr.send(file);
    },
    //------------------------------------------------- URL VARIABLES
    getUrlVars: function () {
      var vars = [],
        hash;
      var hashes = window.location.href
        .slice(window.location.href.indexOf("?") + 1)
        .split("&");
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=");
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    },
    //------------------------------------------------- ON SCROLL
    scrollEvents: function () {},
    //------------------------------------------------- ADD TO CART FORM
    addToCart: function (id, options, product) {},
  };

  $(document).ready(function () {
    app.init();
    app.interactive();
    app.plugins();

    $(window)
      .on("scroll", function () {
        app.scrollEvents();
      })
      .scroll();
  });
})(jQuery);
